import * as methods from '../methods';
import { Resource } from '../Resource';
const rootPath = 'me/mobile_devices';
const fromRaw = {
    getMany: (xs) => xs.map(fromRaw.get),
    get: ({ id, mobile_device_id, brand, name, last_connection }) => ({
        id,
        uniqueId: mobile_device_id,
        name,
        brand,
        lastLoggedInAt: last_connection
    })
};
const toRaw = {
    update: ({ brand, name }) => ({
        name,
        brand
    })
};
const mobileDevices = Resource((requesterBuilder) => {
    const getMany = methods.get({ requesterBuilder, rootPath, fromRaw: fromRaw.getMany });
    const buildKeysToInvalidate = () => [getMany().invalidationKey];
    return {
        getMany,
        update: methods.update({
            method: 'PATCH',
            requesterBuilder,
            rootPath,
            fromRaw: fromRaw.get,
            toRaw: toRaw.update,
            buildKeysToInvalidate
        }),
        delete: methods.deletion({ requesterBuilder, rootPath, buildKeysToInvalidate })
    };
});
export default mobileDevices;
